import {ProjectFeatureFlag} from 'common/report/constants';
import {Features} from 'common/report/stores/features';

import {NavCategoryType, REPORT_INFO} from './constants';
import {NavCategories, NavReports, ReportContext} from './types';

export function getNavReports(features: Features, isProjectOrGlobalWorkspace: boolean, projectId: number): NavReports {
  const reportContext: ReportContext = {features, isProjectOrGlobalWorkspace, projectId};
  return Object.keys(REPORT_INFO).reduce((obj, key) => {
    const report = REPORT_INFO[key];
    const result = {
      ...report,
      name: key,
      category: report.category && report.category(reportContext),
      endpoint: report.endpoint && report.endpoint(reportContext),
      hidden: report.hidden && report.hidden(reportContext),
    };
    obj[key] = result;
    return obj;
  }, {});
}

export function getNavReportsFromCategory(
  categoryType: NavCategoryType,
  features: Features,
  isProjectOrGlobalWorkspace: boolean,
  projectId: number,
): NavReports {
  const navReports = getNavReports(features, isProjectOrGlobalWorkspace, projectId);
  return Object.keys(navReports)
    .filter((report) => navReports[report].category === categoryType)
    .reduce((obj, key) => {
      obj[key] = navReports[key];
      return obj;
    }, {});
}

export function getNavCategories({
  features,
  isDemo,
  isProjectOrGlobalWorkspace,
  projectId,
}: {
  features: Features;
  isDemo: boolean;
  isProjectOrGlobalWorkspace: boolean;
  projectId: number;
}): NavCategories {
  const getReports = function (categoryType) {
    return getNavReportsFromCategory(categoryType, features, isProjectOrGlobalWorkspace, projectId);
  };

  const categories: NavCategories = {
    analysis: {
      label: NavCategoryType.Analysis,
      twoColumn: true,
      reports: getReports(NavCategoryType.Analysis),
    },

    users: {
      label: NavCategoryType.Users,
      reports: getReports(NavCategoryType.Users),
    },

    action: {
      label: NavCategoryType.MessagesAndExperiments,
      // Messages & Experiments is under slow deprecation. Don't show for demo projects
      hidden:
        !features.hasProjectFeatureFlag(ProjectFeatureFlag.MessagesAndExperiments) ||
        features.hasProjectFeatureFlag(ProjectFeatureFlag.HideMenuMessages) ||
        isDemo,
      reports: getReports(NavCategoryType.MessagesAndExperiments),
    },

    dataManagement: {
      label: NavCategoryType.DataManagement,
      reports: getReports(NavCategoryType.DataManagement),
    },
  };

  // set name for each category and report based on its prop key and filter out hidden objects
  for (const [categoryName, category] of Object.entries(categories)) {
    category.name = categoryName;
    category.hidden && delete categories[categoryName];

    for (const [reportName, report] of Object.entries(category.reports)) {
      if (report.hidden) {
        delete category.reports[reportName];
      }
    }
  }

  return categories;
}
